/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");
import * as fileHelper from "../shared/file.helper";

import { Injectable, Inject } from '@angular/core';

export function initialize(module: ng.IModule) {
    module.service(RequirementSectionDataService.Id, RequirementSectionDataService);

    RequirementSectionDataService.$inject = ["entityManagerService", "breeze", "$log", "$q", "$http"];
}

@Injectable()
export class RequirementSectionDataService extends base.BaseDataService<Nema.Crew.Model.CompetenceRequirementCollection> implements IRequirementSectionDataService {

    private $http: ng.IHttpService;

    constructor(entityManagerService: service.EntityManagerService,
        breeze,
        $log,
        $q: ng.IQService,
        //$http: ng.IHttpService,
        @Inject("$http") $http: ng.IHttpService) {
        super(entityManagerService, breeze, $log, $q);

        this.$http = $http;
    }

    public static Id: string = "requirementSectionDataService";

    public get EntityName(): string {
        return "CompetenceRequirementCollection";
    }

    public get EntitiesName(): string {
        return "CompetenceRequirementCollections";
    }

    protected deleteRelatedEntities(entity: Nema.Crew.Model.CompetenceRequirementCollection): Promise<void> {
        return super
            .deleteRelatedEntities(entity)
            .then(() => {
                entity.CompetenceRequirementCollectionWorkplaces.forEach(entity => (<breeze.Entity><any>entity).entityAspect.entityState = this.breeze.EntityState.Deleted);
                return this.entityManager.saveChanges();
            })
            .then(() => {
                return this.deleteFileContent(fileHelper.getRequirementSectionFileDownloadUrl(entity.Id));
            })
            .then();
    }

    public newRequirementSectionWorkplace(defaultWorkplaceId: number): Nema.Crew.Model.CompetenceRequirementCollectionWorkplace {
        return <Nema.Crew.Model.CompetenceRequirementCollectionWorkplace><any>this.entityManager.createEntity('CompetenceRequirementCollectionWorkplace', <Nema.Crew.Model.CompetenceRequirementCollectionWorkplace>{
            WorkplaceId: defaultWorkplaceId
        });
    }

    public saveFileContent(file: File, serviceUrl: string): ng.IHttpPromise<any> {
        var url = serviceUrl + "?fileName=" + encodeURIComponent(file.name);
        return this.$http.put(url, file);
    }

    public deleteFileContent(serviceUrl: string): ng.IHttpPromise<any> {
        return this.$http.delete(serviceUrl);
    }

    public newRequirementSection(authorityId: number): Nema.Crew.Model.CompetenceRequirementCollection {
        return <Nema.Crew.Model.CompetenceRequirementCollection><any>this.entityManager.createEntity('CompetenceRequirementCollection', <Nema.Crew.Model.CompetenceRequirementCollection>{
            AuthorityId: authorityId,
        });
    }
}

export interface IRequirementSectionDataService extends base.IDataService<Nema.Crew.Model.CompetenceRequirementCollection> {
    EntityName: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/requirementsections.dataservice.ts